<template>
    <v-container class="container">
        <v-expansion-panels
            v-model="panel"
            class="expansion-panel"
            :disabled="!this.isAdmin"
        >
            <v-expansion-panel>
                <v-expansion-panel-header class="card-title mt-1">
                    <div class="user-panel">
                        <div>
                            Χρήστες
                            <v-icon v-if="this.isAdmin" :color="theming.cardsAndTablesText || 'black'" class="px-4" @click.stop="togglePanel()" large>
                                mdi-tune
                            </v-icon>
                        </div>
                        <div class="create-btn-wrapper">
                            <v-btn v-if="this.isAdmin" class="my-2 mr-2" dark small color="black" @click="goToCreateUser">
                                <v-icon dark>mdi-plus</v-icon>ΔΗΜΙΟΥΡΓΙΑ
                            </v-btn>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-divider/>
                <v-expansion-panel-content>
                    <div class="filters">
                        <v-select
                            v-model="selectedContractorId"
                            :items="contractors"
                            item-value="id"
                            item-text="name"
                            label="Εργολάβος"
                            clearable
                            outlined
                            class="filter-field contractors"
                        ></v-select>
                    </div>
                    <div class="search-button-wrapper">
                        <v-btn class="mx-2 white--text" medium color="black" @click="getUsers">
                            <v-icon medium class="bulding-id-icon">mdi-filter</v-icon> Αναζητηση
                        </v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-dialog
            v-model="editDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h6">
                    Θέλετε να επεξεργαστείτε τον χρήστη;
                </v-card-title>
                <v-card-text v-if="this.selectedUser"><h3>{{ this.selectedUser.firstName }} {{ this.selectedUser.lastName }}</h3></v-card-text >
                <v-divider />
                <v-card-actions class="card-actions">
                    <v-btn
                        class="white--text"
                        color="green"
                        @click="editUser"
                    >
                        Ναι
                    </v-btn>
                    <v-btn
                        class="white--text"
                        color="red"
                        @click="editDialog = false"
                    >
                        ΟΧΙ
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <array-view class="table" :items="users" :headers="headers" :totalPages="totalPages" :page="page" :size="size" @paginationChange="paginationChange" @item-clicked="userSelect"/>
    </v-container>
</template>
<script>
    import user from '@/services/user'
    import ArrayView from '@/components/ArrayView.vue'
    import jwtUtil from '@/utils/jwtUtil'
    import client from '@/services/client'

    export default {
        components: { ArrayView },
        computed: {
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            isAdmin() {
                return this.containsAny(['ROLE_ADMIN'], this.userRoles)
            }
        },
        data() {
            return {
                users: [],
                headers: [
                    {
                        text: 'ID',
                        align: 'start',
                        sortable: false,
                        value: 'id'
                    },
                    { text: '', value: 'avatar' },
                    { text: 'Access', value: 'banned' },
                    { text: 'Όνομα', value: 'firstName' },
                    { text: 'Επώνυμο', value: 'lastName' },
                    { text: 'Contractor', value: 'contractor.name' },
                    { text: 'Ρόλοι', value: 'roles' }
                ],
                sizes: [5, 10, 30, 60, 100],
                page: 1,
                size: 5,
                totalPages: 0,
                contractors: [],
                sort: null,
                panel: null,
                filter: {},
                selectedContractorId: null,
                editDialog: false,
                selectedUser: null,
                clients: []
            }
        },
        created() {
            this.getUsers()
            this.getAllClients()
        },
        methods: {
            userSelect(e) {
                if (this.isAdmin) {
                    this.selectedUser = e
                    this.editDialog = true
                }
            },
            editUser() {
                if (!this.selectedUser) {
                    return
                }
                this.editDialog = false
                this.$router.push('/edit-user/' + this.selectedUser.id)
            },
            goToCreateUser() {
                this.$router.push('/create-user')
            },
            getUsers() {
                if (!this.selectedContractorId) {
                    this.filter = {}
                } else {
                    this.filter = { contractor: { id: this.selectedContractorId } }
                }

                user.getUsers(this.page, this.size, this.filter, this.sort).then(resp => {
                    this.users = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            togglePanel() {
                if (!this.isAdmin) {
                    return
                }
                const curr = this.panel
                this.panel = curr === undefined ? 0 : undefined
            },
            paginationChange(page, size) {
                this.page = page
                this.size = size
                this.getUsers()
            },
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    this.contractors = this.clients.flatMap(client => client.contractors).filter(contractor => contractor.assignee === true)
                })
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            }
        }
    }
</script>
<style scoped>
.container {
    padding-top: 3%;
}
.search-button-wrapper {
    display: flex;
    justify-content: center;
}
.name {
    font-weight: bold;
    font-size: calc(1vw + 2vh);
}
.card-title {
    font-weight: 500;
    font-size: 1.4rem;
}
.table {
    width: 85%;
}

.expansion-panel {
    max-width: 90%;
    margin: 0 auto;
}

@media only screen and (max-width: 540px) {
.expansion-panel {
    max-width: 100%;
}

}
.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}
.create-new {
    display: flex;
    justify-content: end;
}

.filter-field {
    padding: 0.8rem;
}

.contractors {
    min-width: 250px;
    max-width: 400px;
}

.filters {
    display: flex;
    justify-content: center;
}
.card-actions {
    display: flex;
    justify-content: center;
}
.user-panel {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
</style>
